export var QUICKBET_CANCEL_BIG_STAKE_REQUEST = 'QUICKBET_CANCEL_BIG_STAKE_REQUEST';
export var QUICKBET_SUCCESS_BIG_STAKE_REQUEST_CANCEL = 'QUICKBET_SUCCESS_BIG_STAKE_REQUEST_CANCEL';
export var QUICKBET_FAILURE_BIG_STAKE_REQUEST_CANCEL = 'QUICKBET_FAILURE_BIG_STAKE_REQUEST_CANCEL';
export var CANCEL_BIG_STAKE_REQUEST = 'CANCEL_BIG_STAKE_REQUEST';
export var SUCCESS_BIG_STAKE_REQUEST_CANCEL = 'SUCCESS_BIG_STAKE_REQUEST_CANCEL';
export var FAILURE_BIG_STAKE_REQUEST_CANCEL = 'FAILURE_BIG_STAKE_REQUEST_CANCEL';



// WEBPACK FOOTER //
// ./src/actions/BigStakeRequest.js